import { listsActionTypes } from './Constants';

export function getRecentListsRequest(data) {
	return {
		type: listsActionTypes.GET_RECENT_LISTS_REQUEST,
		payload: data,
	};
}

export function getRecentListsSuccess(recentLists) {
	return {
		type: listsActionTypes.GET_RECENT_LISTS_SUCCESS,
		payload: {
			recentLists,
		},
	};
}

export function getRecentListsError() {
	return {
		type: listsActionTypes.GET_RECENT_LISTS_ERROR,
	};
}

export function getRecentItems(data) {
	return {
		type: listsActionTypes.GET_RECENT_ITEMS_REQUEST,
		payload: data,
	};
}

export function getRecentItemsSuccess(data) {
	return {
		type: listsActionTypes.GET_RECENT_ITEMS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getRecentItemsError() {
	return {
		type: listsActionTypes.GET_RECENT_ITEMS_ERROR,
	};
}

export function getMadeListsRequest(queries) {
	return {
		type: listsActionTypes.GET_MADE_LISTS_REQUEST,
		payload: { queries },
	};
}

export function getMadeListsSuccess(madeLists) {
	return {
		type: listsActionTypes.GET_MADE_LISTS_SUCCESS,
		payload: {
			madeLists,
		},
	};
}

export function getMadeListsError() {
	return {
		type: listsActionTypes.GET_MADE_LISTS_ERROR,
	};
}

export function getFoldersRequest(inMenu) {
	return {
		type: listsActionTypes.GET_FOLDERS_REQUEST,
		payload: { inMenu },
	};
}

export function getFoldersSuccess(folders) {
	return {
		type: listsActionTypes.GET_FOLDERS_SUCCESS,
		payload: {
			folders,
		},
	};
}

export function getFoldersError() {
	return {
		type: listsActionTypes.GET_FOLDERS_ERROR,
	};
}

export function getRecentLessons(userId) {
	return {
		type: listsActionTypes.GET_RECENT_LESSONS_REQUEST,
		payload: {
			userId,
		},
	};
}

export function getRecentLessonsSuccess(lessons) {
	return {
		type: listsActionTypes.GET_RECENT_LESSONS_SUCCESS,
		payload: {
			lessons,
		},
	};
}

export function getRecentLessonsError() {
	return {
		type: listsActionTypes.GET_RECENT_LESSONS_ERROR,
	};
}

export function createFolderRequest(options, noRedirect) {
	return {
		type: listsActionTypes.CREATE_FOLDER_REQUEST,
		payload: {
			options,
			noRedirect,
		},
	};
}

export function resendEmailVerification(userId, email) {
	return {
		type: listsActionTypes.RESEND_EMAIL_VERIFICATION_REQUEST,
		payload: {
			userId,
			email,
		},
	};
}

export function resendEmailVerificationSuccess() {
	return {
		type: listsActionTypes.RESEND_EMAIL_VERIFICATION_SUCCESS,
	};
}

export function resendEmailVerificationError() {
	return {
		type: listsActionTypes.RESEND_EMAIL_VERIFICATION_ERROR,
	};
}

export function confirmEmailRequest(accountId, confirmationToken) {
	return {
		type: listsActionTypes.CONFIRM_EMAIL_REQUEST,
		payload: {
			accountId,
			confirmationToken,
		},
	};
}

export function confirmEmailSuccess() {
	return {
		type: listsActionTypes.CONFIRM_EMAIL_SUCCESS,
	};
}

export function confirmEmailError() {
	return {
		type: listsActionTypes.CONFIRM_EMAIL_ERROR,
	};
}

export function createFolderSuccess(data) {
	return {
		type: listsActionTypes.CREATE_FOLDER_SUCCESS,
		payload: {
			data,
		},
	};
}

export function createFolderError() {
	return {
		type: listsActionTypes.CREATE_FOLDER_ERROR,
	};
}

export function setLoading() {
	return {
		type: listsActionTypes.SET_LOADING,
		payload: {},
	};
}

export function cleanListsState() {
	return {
		type: listsActionTypes.CLEAN_LISTS_STATE,
	};
}

export function clearMadeList() {
	return {
		type: listsActionTypes.CLEAN_MADE_LIST_STATE,
	};
}

export function hideOnboardingTasks() {
	return {
		type: listsActionTypes.HIDE_ONBOARDING_TASKS_REQUEST,
	};
}
export function hideItemRequest(link, callback) {
	return {
		type: listsActionTypes.HIDE_RECENT_ITEM_REQUEST,
		payload: { link, callback },
	};
}
export function hideItemSuccess(listType, id) {
	return {
		type: listsActionTypes.HIDE_RECENT_ITEM_SUCCESS,
		payload: { listType, id },
	};
}
